export default "__VITE_ASSET__TOrSOoOe__"